import { call, takeLatest, put } from 'redux-saga/effects';

import { history } from '@utils/history';
import { Claim } from '@models/Claim';
import { ClaimApi } from '@apis/ClaimApi';
import {
  stateUpdate,
  StateUpdatePayload,
  userClaimAdditionalDocumentsUpload,
  UserClaimAdditionalDocumentsUploadPayload,
} from './action';
import { SagaPayload } from '@utils/typescript';

function* handleUserAdditionalDocumentsCreate({ payload }: SagaPayload<UserClaimAdditionalDocumentsUploadPayload>) {
  const state: StateUpdatePayload = { claim: null };
  try {
    // FIXED: ClaimApi.updateDocuments()
    state.claim = (yield call(ClaimApi.uploadAdditionalDocuments, payload)) as Claim;
    const { claimableType, claimableId } = state.claim;
    history.navigate(`/user-dashboard/claim/${claimableType}/${claimableId}`, { replace: true });
    yield put(stateUpdate(state));
  } catch {}
}

export default function* () {
  yield takeLatest(userClaimAdditionalDocumentsUpload, handleUserAdditionalDocumentsCreate);
}
